import _ from 'lodash'
import React from 'react'
import SelectMultipleWithData from './SelectMultipleWithData'

export const SelectListMultipleAdhoc = (props, ref) => {

  const options = props.dataRows ?? _.get(props, 'data.field.field_data.params.options', [])

  const dataRows = (options ?? []).map((o) => {
    return { key: o.key, label: o.label, value: o.value }
  })

  return (
    <SelectMultipleWithData
      {...props}
      dataRows={dataRows}
      labelField="label"
      keyField="key"
      valueField="key"
      value={props.defaultValue}
    />
  )
}
